window.addEventListener("DOMContentLoaded", () => {
	ic_youtube()
	ic_youtube_resize()
})

//Gestion des IC blocks Youtube
const ic_youtube = () => {

	const blocks = document.querySelectorAll(".wp-block-ic-blocks-youtube")

	if (blocks) {

		//Pour chaque block présent sur la page
		blocks.forEach( block => {

			//Si le block est fullscreen, on appelle une fonction qui va mettre à jour les dimensions de l'iframe
			// en fonction du ratio de l'écran
			const fullscreen = block.classList.contains("fullscreen")
			if (fullscreen) {
				ic_youtube_ratio(block)
			}

			//On se sert des classes du container du block pour connaitre le paramétrage de la vidéo
			//En boolean 0 ou 1 car l'API Youtube ne gère pas le true/false
			const autoplay = block.classList.contains("autoplay") ? 1 : 0
			const default_controls = block.classList.contains("controls-default") ? 1 : 0
			const muted = block.classList.contains("muted") ? 1 : 0
			const loop = block.classList.contains("loop") ? 1 : 0

			//On récupère le container de la vidéo, pour y injecter l'iframe via l'API Youtube
			const player = block.querySelector(".youtube-video")
			let iframe
			window.YT.ready( () => {
				iframe = new YT.Player(player, {
					videoId: player.dataset.src,
					playerVars: {
						controls:default_controls,
						autoplay:0,
						disablekb:1,
						enablejsapi:1,
						iv_load_policy:3,
						modestbranding:1,
						showinfo:0,
						rel:0,
						playsinline: 1,
					},
					events: {
						'onReady' : () => {
							//Au chargement de la vidéo, on force l'autoplay si nécessaire
							muted && iframe.mute()
							autoplay && iframe.playVideo()
						},
						'onStateChange' : e => {
							//A la fin de la vidéo, ou la relance si nécessaire
							(loop && e.data === YT.PlayerState.ENDED) && iframe.seekTo(0)
						}
					}
				})
			})

			//Si la vidéo comporte des commandes personnalisées, on gère le clic sur ce bouton de commande
			//Qui viendra toggle la vidéo, entre play() et pause()
			const custom_controls = block.classList.contains("controls-custom")
			if (custom_controls) {
				const controls = block.querySelector(".controls")
				controls.addEventListener("click", () => {
					if (block.classList.contains("playing")){
						iframe.pauseVideo()
						block.classList.remove("playing")
					}else {
						iframe.playVideo()
						block.classList.add("playing")
					}
				})
			}

		})
	}
}

//Créé une détection de redimensionnement d'écran si on a des vidéos fullscreen sur la page
const ic_youtube_resize = () => {
	const blocks = document.querySelectorAll(".wp-block-ic-blocks-youtube.fullscreen")
	if (blocks) {
		window.addEventListener("resize", ic_youtube_on_resize)
	}
}

//Parcourt tous les blocs en fullscreen pour mettre à jour leurs dimensions
const ic_youtube_on_resize = () => {
	const blocks = document.querySelectorAll(".wp-block-ic-blocks-youtube.fullscreen")
	blocks.forEach( block => {
		ic_youtube_ratio(block)
	})
}

//Met à jour les dimensions d'une vidéo fullscreen en fonction du ratio de l'écran
const ic_youtube_ratio = block => {
	const window_width = window.innerWidth
	const window_height = window.innerHeight
	if (window_height * 1.5625 < window_width) {
		block.classList.add("ratio-2")
	}else {
		block.classList.remove("ratio-2")
	}
}
